import { DateTime } from "luxon";

export function extractHeatEnergySum(data: any): any[] {
  if (!data || !Array.isArray(data)) {
    return [];
  }


  const filtered = data.filter((item: any) => {
    const hasItem = !!item;
    const hasBlock = !!item?.block;

    // Try multiple possible locations for heat_energy_sum
    const heatEnergySumValue =
      item?.block?.heat_energy_sum ||
      item?.heat_energy_sum ||
      item?.block_data?.heat_energy_sum ||
      item?.data?.heat_energy_sum;

    const isNumericString = typeof heatEnergySumValue === "string" && !isNaN(Number(heatEnergySumValue));
    const isNumber = typeof heatEnergySumValue === "number";
    const hasHeatEnergySum = (isNumber || isNumericString) && heatEnergySumValue != null;


    return hasItem && hasHeatEnergySum;
  });


  return filtered.map((item: any) => {
    const heatEnergySumValue =
      item?.block?.heat_energy_sum ||
      item?.heat_energy_sum ||
      item?.block_data?.heat_energy_sum ||
      item?.data?.heat_energy_sum;

    // Extract month name from block name for proper chart display
    const monthMatch = item.block_name?.match(/core_(\d{4})-(\d{2})/);
    let month_name = item.block_name;

    if (monthMatch) {
      const [, year, month] = monthMatch;
      const date = DateTime.fromObject({ year: parseInt(year), month: parseInt(month) });
      month_name = date.toFormat("MMM yyyy");
    }

    return {
      block_name: item.block_name,
      month_name,
      heat_energy_sum: Number(heatEnergySumValue), // Convert string to number
    };
  });
}

export function getPast12MonthsBlockNames(): string[] {
  let currentDate = DateTime.now().minus({ months: 12 }).startOf("month");
  const blockNames: string[] = [];
  for (let i = 0; i < 12; i++) {
    blockNames.push(`core_${currentDate.toFormat("yyyy-MM")}`);
    currentDate = currentDate.plus({ months: 1 });
  }
  return blockNames;
}

export function getPrevious12MonthsBlockNames(): string[] {
  let currentDate = DateTime.now().minus({ months: 24 }).startOf("month");
  const blockNames: string[] = [];
  for (let i = 0; i < 12; i++) {
    blockNames.push(`core_${currentDate.toFormat("yyyy-MM")}`);
    currentDate = currentDate.plus({ months: 1 });
  }
  return blockNames;
}

export function getPast5YearsBlockNames(): string[] {
  let currentDate = DateTime.now().minus({ years: 5 }).startOf("year");
  const blockNames: string[] = [];
  for (let i = 0; i < 5; i++) {
    blockNames.push(`core_${currentDate.toFormat("yyyy")}`);
    currentDate = currentDate.plus({ years: 1 });
  }
  return blockNames;
}

export function convertKwhToMwh(kwh: number): number {
  if (typeof kwh !== "number" || isNaN(kwh)) return 0;
  return kwh / 1000;
}

export function formatNumber(num: number | string): string {
  if (typeof num === "string") return num;
  if (typeof num !== "number" || isNaN(num)) return "0";
  return num.toFixed(1);
}

export function roundNumber(num: number): number {
  if (typeof num !== "number" || isNaN(num)) return 0;
  return Math.round(num);
}
